import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import {
  ManageUsersComponent,
  UserRegistrationComponent,
  SchoolListComponent
} from './components';
import { DialogModule } from 'primeng/dialog';
import {
  DuplicateFieldValidatorDirective,
  OneEducationCoreModule
} from '@oneeducation/app-core';

@NgModule({
  declarations: [
    ManageUsersComponent,
    UserRegistrationComponent,
    SchoolListComponent
  ],
  imports: [
    MessageModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    SelectModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    DialogModule,
    OneEducationCoreModule
  ],
  providers: [DuplicateFieldValidatorDirective],
  exports: [
    ManageUsersComponent,
    UserRegistrationComponent,
    SchoolListComponent
  ]
})
export class UserManagementModule {}
